import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '30px 60px',
  },
  typeSelectorContainer: {
    margin: theme.spacing(1),
    minWidth: '200px',
  },
  normalTextContainer: {
  },
}));

export default useStyles;
